'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../stores/CartStore.jsx');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore.jsx');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _Actions = require('../../Actions.jsx');

var _Actions2 = _interopRequireDefault(_Actions);

var _Utility = require('../../utils/Utility.jsx');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurbsidePickupAddressView = function (_React$Component) {
    _inherits(CurbsidePickupAddressView, _React$Component);

    function CurbsidePickupAddressView(props) {
        _classCallCheck(this, CurbsidePickupAddressView);

        var _this = _possibleConstructorReturn(this, (CurbsidePickupAddressView.__proto__ || Object.getPrototypeOf(CurbsidePickupAddressView)).call(this, props));

        _this.onVehicleMakeModelChanged = function (e) {
            _this.setState({
                vMakeModel: e.target.value
            }, function () {
                _this.handleCallBackToParent();
            });
        };

        _this.onVehicleColorChanged = function (e) {
            _this.setState({
                vColor: e.target.value
            }, function () {
                _this.handleCallBackToParent();
            });
            // Actions.addOrderVehicleColor(e.target.value);
        };

        _this.clickedPreferCurbside = function (e) {
            // console.log("clickedPreferCurbside: "+ e.target.checked);

            var preferCurbside = e.target.checked;
            // console.log(preferCurbside);

            _this.setState({
                isPreferCurbside: preferCurbside
            }, function () {
                _this.handleCallBackToParent();
            });
        };

        _this.state = {
            vMakeModel: "",
            vColor: "",
            isPreferCurbside: false,
            curbsideInstructions: ""
        };

        _this.inputTimer = null;
        return _this;
    }

    _createClass(CurbsidePickupAddressView, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _this2 = this;

            var self = this;
            this.setState({
                vMakeModel: _CartStore2.default.getOrderVehicleMakeModel(),
                vColor: _CartStore2.default.getOrderVehicleColor(),
                isPreferCurbside: _CartStore2.default.getIsPreferCurbsideEnabled(),
                curbsideInstructions: _CartStore2.default.getCurbsidePickupInstructions()
            }, function () {
                _this2.handleCallBackToParent();
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps) {

                if (!Utils.isEmptyObj(nextProps.curbSideObj)) {

                    this.setState({
                        vMakeModel: nextProps.curbSideObj.vMakeModel,
                        vColor: nextProps.curbSideObj.vColor,
                        isPreferCurbside: nextProps.curbSideObj.isPreferCurbside
                    });
                }
            }
        }
    }, {
        key: 'handleCallBackToParent',
        value: function handleCallBackToParent() {
            var vMakeModel = this.state.vMakeModel;
            var vColor = this.state.vColor;
            var isPreferCurbside = this.state.isPreferCurbside;

            var obj = {
                vMakeModel: vMakeModel,
                vColor: vColor,
                isPreferCurbside: isPreferCurbside,
                isPickUpLocationSelected: false
            };

            this.props.handleCurbSideChange(obj);
        }
    }, {
        key: 'render',
        value: function render() {
            var locationDetail = _CartStore2.default.getLocationDetail();
            return _react2.default.createElement(
                'div',
                { className: 'panel-default panel-border-less' },
                _react2.default.createElement(
                    'div',
                    { className: 'input-group curbside-div mb-3' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'container-checkbox container-checkbox-pickup pull-left chk-lbl' },
                        _react2.default.createElement(
                            'b',
                            { className: "cart-heading f16-default" },
                            'I prefer curbside'
                        ),
                        _react2.default.createElement('input', {
                            id: 'prefer-curbside',
                            type: 'checkbox',
                            name: 'prefer-curbside',
                            checked: this.state.isPreferCurbside,
                            onChange: this.clickedPreferCurbside
                        }),
                        _react2.default.createElement('span', { className: 'checkmark checkmark-right' })
                    )
                ),

                // this.props.scheduleScreenStore.isPreferCurbside ? (
                this.state.isPreferCurbside ? _react2.default.createElement(
                    'div',
                    { className: 'curbside-form-div' },
                    this.state.curbsideInstructions ? _react2.default.createElement(
                        'label',
                        { className: 'address-width-ctrl selected-address-label' },
                        this.state.curbsideInstructions
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'col-lg-12 form-group curbside-pickup-instruction' },
                        _react2.default.createElement(
                            'label',
                            { className: 'address-width-ctrl selected-address-label curbside-ins cart-header' },
                            _react2.default.createElement(
                                'b',
                                { className: 'list-group-item-heading' },
                                'Tell us how to identify you when you arrive.'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { className: 'address-width-ctrl selected-address-label cart-header' },
                                'Vehicle Color:'
                            ),
                            _react2.default.createElement('input', {
                                type: 'text',
                                id: 'vehicle_color',
                                name: 'vehicle_color',
                                className: 'form-control curbside-input-field text-secondary-light rounded-sm',
                                placeholder: 'Enter the vehicle color',
                                title: 'Enter the vehicle color',
                                onChange: this.onVehicleColorChanged,
                                value: this.state.vColor
                                // value={this.props.scheduleScreenStore.scheduleScreenUpdatedObject.vColor}
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                { className: 'address-width-ctrl selected-address-label cart-header' },
                                'Vehicle Make & Model:'
                            ),
                            _react2.default.createElement('input', {
                                type: 'text',
                                id: 'vehicle_make_modal',
                                name: 'vehicle_make_modal',
                                className: 'form-control curbside-input-field text-secondary-light rounded-sm',
                                placeholder: 'Enter the vehicle make & model',
                                title: 'Enter the vehicle make & model',
                                onChange: this.onVehicleMakeModelChanged,
                                value: this.state.vMakeModel
                                // value={this.props.scheduleScreenStore.scheduleScreenUpdatedObject.vMakeModel}
                            })
                        )
                    )
                ) : null
            );
        }
    }]);

    return CurbsidePickupAddressView;
}(_react2.default.Component);

exports.default = CurbsidePickupAddressView;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/CurbsidePickupAddressView.jsx
// module id = 495
// module chunks = 0